import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import {
  inviteUserForJoiningEvents,
  getUserFriends
} from "../../../redux/actions";
import PropTypes from "prop-types";
// import { ImageUrl } from "../../../utils/constants";
import { COMPANY_NAME } from "../../../utils/config";
import { isNull } from "lodash";
import {
  StyledInput,
  InputWrapper
} from './styles';
import { CustomcheckboxBtn } from "../../CreateEvent/style";
import { StyledModal, CustomTitle } from "../../AttendeesModal/styles";
import { Border } from "../../Journeys/styles";
import { AdminCloseIcon, Checkmark } from "../../../utils/icons";
// import { CommonButtonBorder } from "../../common/commonStyles";
import Image from "../../Image";
import { NameInitials } from "../../Manager/styles";
import { getInitials } from "../../../utils/methods";
class InviteAmigoPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amigosList: [],
      uninviteUids: [],
      searchedPeopleArray:[],
      searchInput: "",
    };
  }

  componentDidMount() {
    const { getUserFriends, userId } = this.props;
    getUserFriends(userId);
  }

  inviteAmigo = (amigo, alreadyInvited) => {
    const { amigosList, uninviteUids } = this.state;
    if (alreadyInvited) {
      if (uninviteUids.includes(amigo)) {
        let index = uninviteUids.findIndex((item) => item === amigo);
        if (index > -1) {
          uninviteUids.splice(index, 1);
        }
        amigosList.push(amigo);
      } else {
        uninviteUids.push(amigo);
        let index = amigosList.findIndex((item) => item === amigo);
        if (index > -1) {
          amigosList.splice(index, 1);
        }
      }
    } else if (amigosList.includes(amigo)) {
      let index = amigosList.findIndex((item) => item === amigo);
      if (index > -1) {
        amigosList.splice(index, 1);
      }
    } else {
      amigosList.push(amigo);
    }
    this.setState({
      amigosList: amigosList,
      uninviteUids: uninviteUids,
    });
  };

  selectAllAmigos = (e) => {
    e.preventDefault();
    const { inviteAmigosList } = this.props;
    const { searchInput, searchedPeopleArray } = this.state;
    const invitePeopleList = searchedPeopleArray && searchInput ? searchedPeopleArray : inviteAmigosList;
    
    if (this.state.amigosList.length === invitePeopleList?.length) {
      const uninviteUid = [];
      invitePeopleList.forEach((amigo) => {
        if (amigo.is_invited) uninviteUid.push(amigo.friend_id);
      });
      this.setState({ amigosList: [], uninviteUids: uninviteUid });
    } else {
      const invitedAmigos = invitePeopleList.map((amigo) => amigo.friend_id);
      this.setState({ amigosList: invitedAmigos, uninviteUids: [] });
    }
  };

  redirectChallengeOnHide = () => {
    const { onHide, history, eventId, plusAmigoButton } = this.props;
    if (!plusAmigoButton) history.push(`/events/${eventId}`);
    onHide();
  };

  onInvite = () => {
    const { amigosList, uninviteUids } = this.state;
    const { eventId, inviteUserForJoiningEvents, userId, plusAmigoButton, history } = this.props;
    const object = {
      user_ids: amigosList,
      uninvite_uids: uninviteUids,
      event_id: eventId,
      is_attending: 2,
    };
    inviteUserForJoiningEvents(object, userId);
    this.setState({ amigosList: [], uninviteUids: [] });
    if (!plusAmigoButton) history.push(`/events/${eventId}`);
  };

  componentDidUpdate(prevProps) {
    const { inviteAmigosList } = this.props;
    if (
      prevProps.inviteAmigosList !== inviteAmigosList &&
      inviteAmigosList?.length > 0 &&
      !isNull(inviteAmigosList[0])
    ) {
      const { amigosList } = this.state;
      inviteAmigosList.forEach((data) => {
        if (data.is_invited && !amigosList.includes(data.friend_id))
          amigosList.push(data.friend_id);
      });
      this.setState({ amigosList: amigosList });
    }
  }

  onChangeInput = (e) => {
    this.setState({ searchInput: e.target.value }, () => {
      this.searchArray(this.state.searchInput, this.props.inviteAmigosList);
    });
  };

  searchArray = (input, array) => {
    const results = array?.length && array.filter((item) => 
      item.fullname.toLowerCase().includes(input.toLowerCase())
    );
    this.setState({ searchedPeopleArray: results });
  };

  fallBack = (e) => {
    e.target.src = '/public/images/fallback.png';
  };

  render() {
    const { showModal, inviteAmigosList } = this.props;
    const { amigosList, searchInput, searchedPeopleArray } = this.state;
    const showListStatus = inviteAmigosList?.length > 0 && !isNull(inviteAmigosList[0]);
    const invitePeopleList = searchedPeopleArray && searchInput ? searchedPeopleArray : inviteAmigosList;
    const buddyLabel = COMPANY_NAME === "Woliba" ? "Buddies" : "Amigos";

    return (
      <StyledModal
        $width="600px"
        $height="auto"
        show={showModal}
        onHide={() => this.redirectChallengeOnHide()}
      >
        <Modal.Header>
          <CustomTitle style={{ background: '#fff', border:'none'}}>
            <div>
              <span>
                Invite Friends
              </span>
              <span className="closeImage">
                <div onClick={() => this.redirectChallengeOnHide()}>
                  {AdminCloseIcon()}
                </div>
              </span>
            </div>
          </CustomTitle>
        </Modal.Header>

        <Border style={{width:"93%", background: '#EFEFEF', margin: '0px 16px 16px 16px'}} />
        
        <p style={{margin:'0', fontFamily:'lato', fontSize:'14px', fontWeight:'20px', color:'#184A61', padding:'0 16px 12px'}}>Who would you like to invite?</p>
        <InputWrapper inputPadding="0 16px 12px 16px">
          <StyledInput
            // placeholder={`Search ${buddyLabel}`}
            name="searchInput"
            onChange={(e) => this.onChangeInput(e)}
            value={searchInput}
            maxLength="100"
            // bgColor="#005C870D"
            // pColor="#005C8799"
            border="1px solid #DCDCDC"
            color="#184A61"
          />
          {showListStatus && invitePeopleList?.length > 0 && (
            <div style={{textAlign:"right", marginTop:"12px", paddingBottom:'12px', borderBottom:'0.75px solid #dcdcdc'}}>
              <span 
                onClick={(e) => this.selectAllAmigos(e)}
                style={{
                  color:"#DA6C74", 
                  cursor:"pointer", 
                  fontSize:"14px", 
                  fontWeight:"500",
                  fontFamily:"Lato"
                }}
              >
                {amigosList.length === invitePeopleList?.length ? "Deselect all" : "Select all"}
              </span>
            </div>
          )}
        </InputWrapper>

        <Modal.Body style={{ overflowY: 'auto', maxHeight: '320px', padding: '0' }}>
          {showListStatus ? (
            invitePeopleList?.length > 0 ? 
              invitePeopleList.map((employee, index) => (
                <div 
                  key={index} 
                  style={{
                    padding: "8px 24px",
                    // borderTop: index === 0 ? "none" : "1px solid #EFEFEF"
                  }}
                >
                  <div style={{display:"flex", alignItems:"center"}}>
                    <div className="image" style={{width:"60px", height:"60px", marginRight:"12px", display:"flex", justifyContent:"center", alignItems:"center"}}>
                      {employee.profile_image !== "profile-Image/default.png" ? (
                        <Image image={employee.profile_image} alt={employee.fullname} />
                      ) : (
                        <NameInitials>{getInitials(employee.fullname)}</NameInitials>
                      )}
                    </div>
                    {/* <div style={{width:"60px", height:"60px", marginRight:"12px"}}>
                     
                      <img 
                        onError={this.fallBack} 
                        src={`${ImageUrl}/${employee.profile_image}`}
                        style={{width:"48px", height:"48px", borderRadius:"50%"}}
                      />
                    </div> */}
                    <div style={{flex:1}}>
                      <span style={{
                        fontSize:"16px", 
                        color:"#184A61", 
                        fontFamily:"Lato", 
                        fontWeight:"400"
                      }}>
                        {employee.fullname}
                      </span>
                    </div>
                    <CustomcheckboxBtn 
                      width="20px"
                      borderRadius="0px"
                      isBorderColor={amigosList.includes(employee.friend_id) ? "1px solid #DA6C74" : "1px solid #7C7C7C"}
                      onClick={employee.is_invited ? null : () => 
                        this.inviteAmigo(employee.friend_id, employee.is_invited)
                      }
                      style={{
                        opacity: employee.is_invited && "50%", 
                        cursor: employee.is_invited ? "not-allowed" : "pointer"
                      }}
                    >
                      {amigosList.includes(employee.friend_id) && (
                        <span>{Checkmark('#DA6C74')}</span>
                      )}
                    </CustomcheckboxBtn>
                  </div>
                </div>
              )) 
              : <div style={{padding:"30px", textAlign:"center", color:"#184A61", fontFamily:"Lato", fontSize:"16px"}}>
                {`No ${buddyLabel} found`}
              </div>
          ) : (
            <div style={{padding:"30px", textAlign:"center", color:"#184A61", fontFamily:"Lato", fontSize:"16px"}}>
              {`No ${buddyLabel} found`}
            </div>
          )}
        </Modal.Body>

        {showListStatus && invitePeopleList?.length > 0 && (
          <div style={{display: 'flex', justifyContent: 'center', margin: '16px auto 16px'}}>
            <div
              style={{
                width: "200px",
                height: "48px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "12px 16px",
                borderRadius: "4px",
                backgroundColor: amigosList?.length ? "#DA6C74" : "#EFEFEF",
                color: amigosList?.length ? "#fff" : "#989898",
                fontFamily: "Lato",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "20px",
                cursor: amigosList?.length ? "pointer" : "not-allowed",
                border: "none"
              }}
              onClick={() => amigosList?.length && this.onInvite()}
            >
              Send Invite
            </div>
          </div>
        )}

      </StyledModal>
    );
  }
}

InviteAmigoPopUp.propTypes = {
  userId: PropTypes.number,
  showModal: PropTypes.bool,
  inviteUserForJoiningEvents: PropTypes.func,
  onHide: PropTypes.func,
  inviteAmigosList: PropTypes.array,
  eventId: PropTypes.number,
  plusAmigoButton: PropTypes.number,
  history: PropTypes.object,
  getUserFriends: PropTypes.func
};

const mapStateToProps = (state) => ({
  inviteAmigosList: state.social.friendList,
});

const mapDispatchToProps = (dispatch) => ({
  inviteUserForJoiningEvents: (data) => dispatch(inviteUserForJoiningEvents(data)),
  getUserFriends: (userId) => dispatch(getUserFriends(userId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteAmigoPopUp);
